import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route-level role guard. Redirects unauthorized users to /dashboard.
 * Usage: <RoleGuard roles={['system_admin', 'meridian_operator']}><PageComponent /></RoleGuard>
 */
export function RoleGuard({ roles, children }) {
  const { user } = useAuth();
  
  if (!user) return null; // Still loading
  
  if (!roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}
